import React, { Fragment, useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Grid,
  Backdrop,
  CircularProgress,
  Divider,
  TextField,
} from "@material-ui/core";
//Notificacion errores https://iamhosseindhv.com/notistack/demos#variants
import { useSnackbar } from "notistack";
//componentes del sistema
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useSelector } from "react-redux";
import { getRUCEmpresa } from "redux/actions/userActions";
import clientBackend, {clientPay} from "configurations/axios";
import Alert from "widgets/alert";
import useForm from "hooks/useFrom";
import validations from "../validations";
import {
  API_GET_ALL_LOCATIONS,
  API_POST_SAVE_PARTNERS,
} from "../apis";
import { useStylesApp } from "hooks/useStyles";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  divForm: {
    marginBottom: "1%",
  },
  divInput: {
    marginBottom: "1%",
    paddingRight: "1%",
    paddingLeft: "0.5%",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
}));

const AddPartnerBtn = ({ updateView }) => {
  const classes = useStyles();
  const classesApp = useStylesApp();
  const classesGlobal = useStylesGlobal();
  const [openLoader, setOpenLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [location, setLocation] = useState([]);
  const [loadLocation, setLoadLocation] = useState(true);
  const [selectedLocation, setSelectedLocation] = useState({
    idUbicacionGeografica: "",
  });
  const userToken = useSelector((state) => state.user.tk);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  const { enqueueSnackbar } = useSnackbar();
  const [partner, setPartner] = useState({
    idEmpresa: userToken ? getRUCEmpresa(userToken) : "0",
    rucEmpresa: "",
    razonSocial: "",
    coordenadaSucursal: "",
    correoElectronico: "",
    dvEmpresa: "",
    direccionEmpresa: "",
    telefono: "",
    tipoContribuyente: "",
  });

  const existError = () => {
    setOpenLoader(false);
  };

  useEffect(() => {
    if (selectedLocation) {
      setPartner({
        ...partner,
        idUbicacionGeografica: selectedLocation.idUbicacionGeografica,
      });
    }
  }, [selectedLocation]);

  const handleSave = async () => {
    await clientPay
      .post(API_POST_SAVE_PARTNERS, partner)
      .then((response) => {
        if (response.status === 200) {
          enqueueSnackbar(`${partner.razonSocial} agregado como partner.`, {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            autoHideDuration: 10000,
          });
          updateView();
          setOpenLoader(false);
          setOpen(false);
        }
      })
      .catch((exception) => {
        if (exception.response) {
          if (exception.response.status === 400) {
            setMsg({ show: true, msg: "No se pudo almacenar el partner." });
          } else if (exception.response.status === 404) {
            setMsg({
              show: true,
              msg: "No se encontró la empresa enviada para relacionarla con el partner. ",
            });
          } else if (exception.response.status === 409) {
            setMsg({ show: true, msg: "El partner ya existe." });
          } else if (exception.response.status === 406) {
            setMsg({ show: true, msg: `${exception.response.data.apierror.mensajeSistema}` });
          } else {
            setMsg({
              show: true,
              msg: "Error al registrar el partner. Contáctese con el administrador del Sistema.",
            });
          }
        } else {
          setMsg({
            show: true,
            msg: "Existen problemas en la red. Contáctese con el administrador del Sistema.",
          });
        }
        setOpenLoader(false);
      });
  };

  const { errors, handleSubmit, getObject } = useForm(
    handleSave,
    validations.addPartner,
    existError
  );

  function closeAlert() {
    setMsg({ show: false });
  }

  const handleClickOpen = () => {
    setOpen(true);
    setLoadLocation(true);
    setPartner({ idEmpresa: getRUCEmpresa(userToken), tipoReceptor: "01" });
    setMsg({ show: false, msg: null, type: null });
    errors.rucEmpresa = null;
    errors.razonSocial = null;
    errors.correoElectronico = null;
    errors.telefono = null;
    errors.dvEmpresa = null;
    errors.coordenadaSucursal = null;
    errors.tipoContribuyente = null;
    setSelectedLocation({ ubicacionGeografica: "" });
  };

  const handleClose = () => {
    setOpen(false);
    setLocation([]);
  };

  const getLocations = async (token) => {
    setLoadLocation(false);
    if (open) {
      await clientBackend
        .get(API_GET_ALL_LOCATIONS)
        .then((result) => {
          if (result.status === 200) {
            let locations = result.data;
            for (let i = 0; i < locations.length; i++) {
              locations[i].label =
                locations[i].nombre + " / " + locations[i].secuencial;
            }
            setLocation(locations);
          }
        })
        .catch((exception) => {
          setLocation([
            { label: "Error al cargar las ubicaciones geográficas" },
          ]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar las ubicaciones geográficas.",
          });
        });
    }
  };

  const renderLocations = () => {
    if (location.length === 0 && userToken && loadLocation) {
      getLocations(userToken);
    }
    return (
      <>
        <Autocomplete
          value={selectedLocation}
          onChange={(event, newValue) => {
            setSelectedLocation(newValue);
          }}
          options={location}
          getOptionLabel={(option) => option.label}
          style={{ width: "95%" }}
          loading={location.length === 0}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Lista de ubicaciones geográficas"
              classes={{ root: classes.textFieldComboBox }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {location.length === 0 ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
        {errors.ubicacionGeografica ? (
          <p className={classesApp.errorLetters}>
            {errors.ubicacionGeografica}
          </p>
        ) : null}
      </>
    );
  };

  const handleChange = (event) => {
    setPartner({
      ...partner,
      [event.target.name]: event.target.value,
    });
    getObject({
      ...partner,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeRazonSocial = (event) => {
    setPartner({
      ...partner,
      [event.target.name]: event.target.value.replace(/[&]/ig, ""),
    });
    getObject({
      ...partner,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeResolucion = (event) => {
    event.preventDefault();
    const re = /[A-Za-z0-9_]/;
    if (event.target.value === "" || re.test(event.target.value)) {
      setPartner({
        ...partner,
        [event.target.name]: event.target.value,
      });
      getObject({
        ...partner,
        [event.target.name]: event.target.value,
      });
    }
  };

  return (
    <Fragment>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        <PersonAddIcon
          style={{ color: palette.primary.contrastText, paddingRight: "3%" }}
          fontSize="small"
        />{" "}
        Agregar Partner
      </Button>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="max-width-dialog-title">Nuevo Partner</DialogTitle>
        <DialogContent>
          <form
            onSubmit={(event) => {
              setOpenLoader(true);
              handleSubmit(event);
            }}
          >
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              <Grid item md={12} xs={12}>
                <label>
                  Los campos marcados con ({" "}
                  <font color={palette.error.main}> *</font> ) son obligatorios:
                </label>
              </Grid>
              {msgError.show ? (
                <Alert
                  tipo={msgError.type}
                  mensaje={msgError.msg}
                  mesajeSubrayado={null}
                  titulo={null}
                  mostrar={msgError.show}
                  cerrarAlerta={closeAlert}
                />
              ) : null}
              <Grid item sm={2}>
                    <label>
                      Ruc: <font color={palette.error.main}> *</font>
                    </label>
                  </Grid>
                  <Grid item sm={4}>
                    <input
                      type="text"
                      className={
                        errors.rucEmpresa
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      onChange={handleChangeResolucion}
                      //required
                      name="rucEmpresa"
                      value={partner.rucEmpresa}
                      placeholder="Ej. 0123456789001"
                      autoComplete="off"
                      maxLength="20"
                    />
                    {errors.rucEmpresa ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.rucEmpresa}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divForm}>
                    <label>
                      Tipo contribuyente:{" "}
                      <font color={palette.error.main}>*</font>
                    </label>
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divInput}>
                    <select
                      name="tipoContribuyente"
                      className={"form-control"}
                      value={partner.tipoContribuyente}
                      onChange={handleChange}
                    >
                      <option value="1">Natural</option>
                      <option value="2">Jurídico</option>
                    </select>
                  </Grid>
                  <Grid item sm={2}>
                    <label>
                      Razón Social: <font color={palette.error.main}> *</font>
                    </label>
                  </Grid>
                  <Grid item sm={4}>
                    <input
                      type="text"
                      className={
                        errors.razonSocial
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      onChange={handleChangeRazonSocial}
                      //required
                      name="razonSocial"
                      value={partner.razonSocial}
                      placeholder="Ej. Empresa C.A."
                      autoComplete="off"
                      maxLength="300" //required
                    />
                    {errors.razonSocial ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.razonSocial}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divForm}>
                    <label>
                      Dígito verificador:
                      <font color={palette.error.main}>*</font>
                    </label>
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divInput}>
                    <input
                      type="number"
                      className={
                        errors.dvEmpresa
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder="Ej. 25"
                      name="dvEmpresa"
                      value={partner.dvEmpresa}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {errors.dvEmpresa ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.dvEmpresa}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item sm={2}>
                    <label>
                      Correo Electrónico:
                      <font color={palette.error.main}> *</font>{" "}
                    </label>
                  </Grid>
                  <Grid item sm={4}>
                    <input
                      type="email"
                      className={
                        errors.correoElectronico
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      onChange={handleChange}
                      name="correoElectronico"
                      value={partner.correoElectronico}
                      placeholder="Ej. info@ejemplo.com.ec"
                      autoComplete="off"
                    //required
                    />
                    {errors.correoElectronico ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.correoElectronico}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item sm={3}>
                    <label>
                      Teléfono:<font color={palette.error.main}>*</font>{" "}
                    </label>
                  </Grid>
                  <Grid item sm={3}>
                    <input
                      type="text"
                      className={
                        errors.telefono
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      onChange={handleChangeResolucion}
                      name="telefono"
                      value={partner.telefono}
                      placeholder="Ej. 021234567"
                      autoComplete="off"
                    />
                    {errors.telefono ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.telefono}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item md={2} xs={12} className={classes.divForm}>
                    <label>
                      Coordenada sucursal:
                      <font color={palette.error.main}>*</font>
                    </label>
                  </Grid>
                  <Grid item md={4} xs={12} className={classes.divInput}>
                    <input
                      type="text"
                      className={
                        errors.coordenadaSucursal
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder="Ej. 8.982189, -79.511994"
                      name="coordenadaSucursal"
                      value={partner.coordenadaSucursal}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {errors.coordenadaSucursal ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.coordenadaSucursal}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divForm}>
                    <label>
                      Código de la sucursal:
                      <font color={palette.error.main}>*</font>
                    </label>
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divInput}>
                    <input
                      type="text"
                      className={"form-control is-valid"}
                      name="codigoSucursal"
                      value={"0001"}
                      disabled
                    />
                  </Grid>
                  <Grid item md={3} xs={12} className={classes.divForm}>
                    <label>
                      Ubicación geográfica:
                      <font color={palette.error.main}>*</font>
                    </label>
                  </Grid>
                  <Grid item md={9} xs={12} className={classes.divInput}>
                    {renderLocations()}
                    {errors.unificadoSucursal ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.unificadoSucursal}
                      </small>
                    ) : null}
                  </Grid>
                  <Grid item sm={3}>
                    <label>
                      Dirección: <font color={palette.error.main}> *</font>
                    </label>
                  </Grid>
                  <Grid item sm={9}>
                    <input
                      type="text"
                      className={
                        errors.direccionEmpresa
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      onChange={handleChange}
                      name="direccionEmpresa"
                      value={partner.direccionEmpresa}
                      placeholder="Ej. Av. y Calle 2"
                      autoComplete="off"
                    />
                    {errors.direccionEmpresa ? (
                      <small style={{ color: palette.error.main }}>
                        {errors.direccionEmpresa}
                      </small>
                    ) : null}
                  </Grid>

              <Grid container spacing={3} justify="center">
                <Grid item md={12} xs={12}>
                  <Divider></Divider>
                </Grid>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classesGlobal.marginButton}
                >
                  Agregar
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  className={classesGlobal.marginButton}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
      <Backdrop className={classes.backdrop} open={openLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
};

export default AddPartnerBtn;
